import { ComponentPropsWithRef } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const Icon = styled.svg<{ $small?: boolean; $rotated?: boolean }>`
  width: ${({ $small }) => ($small ? "0.9375rem" : "1.12513rem")};
  transform: ${({ $rotated }) => ($rotated ? "rotate(90deg)" : "none")};
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithRef<"svg"> {
  small?: boolean;
  rotated?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
